/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import "@polymer/polymer/polymer-element.js";

const $_documentContainer = document.createElement("template");
$_documentContainer.innerHTML = `<dom-module id="cs-youtube-styles">
<template>
  <style>
    :host {
      /** * Colors */
      --cs-theme-age-gate-info-icon-color-light: #f3f3f3;
      --cs-theme-age-gate-info-icon-color-dark: #161616;
      --cs-theme-age-gate-info-icon-color-brand: #ff4747;
      --cs-theme-age-gate-subheading-color-light: #f3f3f3;
      --cs-theme-age-gate-subheading-color-dark: #161616;
      --cs-theme-age-gate-background-image-color-light: #f3f3f3;
      --cs-theme-age-gate-background-image-color-dark: #161616;
    }
  </style>
</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);
